export default __webpack_public_path__ + "static/media/404Icon.797b1e5f.svg";